import React, { useState } from 'react';
import { toast } from 'sonner';
import { Download, FileText, FileSpreadsheet, FileType, Loader2 } from 'lucide-react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';

const FORMATS = [
  { fmt: 'pdf', label: 'PDF', desc: 'Siap cetak', icon: FileText },
  { fmt: 'xlsx', label: 'Excel', desc: '.xlsx dengan filter', icon: FileSpreadsheet },
  { fmt: 'csv', label: 'CSV', desc: 'Impor / data mentah', icon: FileType },
];

/** Standard export: GET `${path}` with `format=` query → downloads the file. `path` is relative to /companies/{id}. */
export const downloadExport = async (companyId, path, fmt, filename) => {
  const sep = path.includes('?') ? '&' : '?';
  const res = await api.get(`/companies/${companyId}${path}${sep}format=${fmt}`, { responseType: 'blob' });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url; a.download = `${filename}.${fmt}`; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
};

export const ExportMenu = ({ companyId, path, filename = 'export', label, size = 'sm', variant = 'outline', className = '', testid = 'export-menu', iconOnly = false }) => {
  const [busy, setBusy] = useState(null);
  const run = async (fmt) => {
    setBusy(fmt);
    try { await downloadExport(companyId, path, fmt, filename); toast.success(`${label || 'Ekspor'} ${fmt.toUpperCase()} siap`); } catch (e) { toast.error(e?.response?.data?.detail || 'Ekspor gagal'); } finally { setBusy(null); }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size={size} variant={variant} className={`rounded-xl ${className}`} disabled={!!busy} data-testid={testid} title={label || 'Ekspor'}>
          {busy ? <Loader2 size={14} className={`animate-spin ${iconOnly ? '' : 'mr-1'}`} /> : <Download size={14} className={iconOnly ? '' : 'mr-1'} />}{!iconOnly && (label || 'Ekspor')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52 rounded-xl">
        <DropdownMenuLabel className="text-xs text-muted-foreground">{label || 'Ekspor'} sebagai</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {FORMATS.map(({ fmt, label: l, desc, icon: Icon }) => (
          <DropdownMenuItem key={fmt} onClick={() => run(fmt)} className="gap-2 rounded-lg cursor-pointer" data-testid={`${testid}-${fmt}`}>
            <Icon size={15} className="text-muted-foreground" /><span className="flex-1"><span className="font-medium">{l}</span><span className="block text-[11px] text-muted-foreground">{desc}</span></span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
